//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tidalDropdown from '@tidal/styles-dropdown/src/components/tidal-dropdown.vue';

/**
 * @typedef {{
 *   image?: string
 *   meta: {
 *     firstName?: string
 *     fullName?: string
 *     imageId?: string
 *     lastName?: string
 *   }
 *   name: string
 *   userName?: string
 * }} User
 *
 * @typedef {{
 *   name?: string
 *   displayName?: string
 *   image?: string
 * }} CurrentUser
 *
 * @typedef {{
 *   name: string
 *   slug: string
 *   url: string
 *   isNuxt: boolean
 * }} NavigationLink
 */

const FALLBACK_TRANSLATIONS = {
    homeText: 'Home',
    featured: 'Featured',
    magazineText: 'Magazine',
    about: 'About',
    loginText: 'Login',
    logoutText: 'Log Out',
    manageAccountText: 'Manage Account',
    myAccountText: 'My Account',
    startFreeTrialText: 'Start Free Trial',
    startFreeTrialShortText: '',
    skipToMain: 'Skip to main content',
    skipToFooter: 'Skip to footer',
};

export default {
    components: {
        tidalDropdown,
    },
    props: {
        login: {
            type: Boolean,
            default: true,
        },
        cta: {
            type: Boolean,
            default: true,
        },
        /** @type {import('vue').PropOptions<NavigationLink[] | boolean>} */
        links: {
            type: [Boolean, Array],
            default: false,
        },
        nuxtLinks: {
            type: Array,
            default: () => [],
        },
        sticky: {
            type: Boolean,
            default: false,
        },
        transparent: {
            type: Boolean,
            default: false,
        },
        disableClickableLogo: {
            type: Boolean,
            default: false,
        },
        disableTidalLogo: {
            type: Boolean,
            default: false,
        },
        disableAbsolutePosition: {
            type: Boolean,
            default: false,
        },
        /**
         * @property {string} name
         * @property {string} [image]
         * @type {import('vue').PropOptions<User>}
         */
        user: {
            type: Object,
            default: null,
        },
        logoutFunc: {
            type: Function,
            default: null,
        },
        loginFunc: {
            type: Function,
            default: null,
        },
        logoutUrl: {
            type: String,
            default: null,
        },
        loginUrl: {
            type: String,
            default: null,
        },
        signupUrl: {
            type: String,
            default: null,
        },
        baseUrl: {
            type: String,
            default: null,
        },
        tidalUrl: {
            type: String,
            default: null,
        },
        manageAccountUrl: {
            type: String,
            default: 'https://my.tidal.com/account',
        },
        active: {
            type: String,
            default: null,
        },
        home: {
            type: String,
            default: null,
        },
        /**
         * @property {string} [translations[].homeText]
         * @property {string} [translations[].featured]
         * @property {string} [translations[].magazineText]
         * @property {string} [translations[].about]
         * @property {string} [translations[].loginText]
         * @property {string} [translations[].logoutText]
         * @property {string} [translations[].manageAccountText]
         * @property {string} [translations[].myAccountText]
         * @property {string} [translations[].startFreeTrialText]
         * @property {string} [translations[].startFreeTrialShortText]
         * @property {string} [translations[].skipToMain]
         * @property {string} [translations[].skipToFooter]
         * @type {import('vue').PropOptions<Record<keyof FALLBACK_TRANSLATIONS, string>>}
         */
        translations: {
            type: Object,
            default: null,
        },
        translationFn: {
            type: Function,
            default: null,
        },
    },
    data() {
        return {
            showMainMenu: false,
            mainContent: false,
            footerContent: false,
            scrollPos: 0,
        };
    },
    computed: {
        /** @return {CurrentUser | undefined} */
        currentUser() {
            if (this.user) {
                /** @type {CurrentUser} */
                const object = {};
                if (this.user.meta) {
                    object.name =
                        this.user.meta.firstName ||
                        this.user.meta.fullName ||
                        this.user.userName ||
                        undefined;
                    object.displayName =
                        this.user.meta.firstName ||
                        this.user.meta.fullName ||
                        undefined;
                    object.image = this.user.meta.imageId ? this.user.meta.imageId.replace(/-/g, '/') : undefined;
                } else {
                    object.name = this.user.userName || undefined;
                }
                return object;
            } else {
                return undefined;
            }
        },
        /** @return {boolean} */
        hasMenu() {
            return this.links === true || this.links && this.links.constructor === Array;
        },
        /** @return {boolean} */
        homeNuxt() {
            return this.nuxtLinks.includes('home');
        },
        /** @return {NavigationLink[]} */
        navigation() {
            return Array.isArray(this.links) ? this.links : [
                {
                    name: this.getTranslation('homeText'),
                    slug: 'home',
                    url: (this.tidalUrl || this._baseUrl) + (this.home || ''),
                    isNuxt: this.homeNuxt,
                },
                {
                    name: this.getTranslation('featured'),
                    slug: 'featured',
                    url: (this.tidalUrl || this._baseUrl) + 'featured',
                    isNuxt: this.nuxtLinks.includes('featured'),
                },
                {
                    name: this.getTranslation('magazineText'),
                    slug: 'magazine',
                    url: (this.tidalUrl || this._baseUrl) + 'magazine',
                    isNuxt: this.nuxtLinks.includes('magazine'),
                },
                {
                    name: this.getTranslation('about'),
                    slug: 'about',
                    url: (this.tidalUrl || this._baseUrl) + 'about',
                    isNuxt: this.nuxtLinks.includes('about'),
                },
            ];
        },
        /** @return {string} */
        _baseUrl() {
            return this.baseUrl || '/';
        },
        /** @return {string} */
        _loginUrl() {
            return this.loginUrl || ((this.tidalUrl || this._baseUrl) + 'login');
        },
        /** @return {string} */
        _signupUrl() {
            return this.signupUrl || ((this.tidalUrl || this._baseUrl) + 'try-now');
        },
        /** @return {string} */
        myAccountText() {
            if (this.currentUser && this.currentUser.displayName) {
                return this.currentUser.displayName;
            }

            return this.getTranslation('myAccountText');
        },
        /** @return {string | null} */
        startFreeTrialShortText() {
            const shortText = this.getTranslation('startFreeTrialShortText');
            if (shortText && shortText !== this.getTranslation('startFreeTrialText')) {
                return shortText;
            }
            return null;
        },
        /** @return {string} */
        logo() {
            return 'data:image/png;base64,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';
        },
        fallbackTranslations() {
            return FALLBACK_TRANSLATIONS;
        },
    },
    watch: {
        /** @type {import('vue').WatchHandler<string>} */
        active() {
            // Make sure menu closes when navigating with nuxt links
            if (this.showMainMenu) {
                this.toggleMainMenu();
            }
        },
    },
    mounted() {
        this.mainContent = !!document.getElementById('main-content');
        this.footerContent = !!document.getElementById('footer-content');
        window.addEventListener('resize', this.checkMainMenu, false);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMainMenu, false);
    },
    methods: {
        /**
         * @param {keyof FALLBACK_TRANSLATIONS} translationKey
         * @return {string}
         */
        getTranslation(translationKey) {
            let translation;

            if (this.translationFn) {
                translation = this.translationFn(translationKey);
            }

            if (!translation && this.translations) {
                translation = this.translations[translationKey];
            }

            const isTranslated = translation && translation !== `webCommon.header.${translationKey}`;
            return isTranslated ? translation : this.fallbackTranslations[translationKey];
        },
        checkMainMenu() {
            // Toggle focus for elements behind the menu
            const menu = /** @type {HTMLDivElement | null} */(this.$refs.menu);
            const isVisible = !!menu && menu.offsetParent !== null;
            this.toggleFocus(isVisible);
        },
        toggleMainMenu() {
            this.showMainMenu = !this.showMainMenu;

            // Toggle focus for elements behind the menu
            this.toggleFocus(this.showMainMenu);

            if (this.showMainMenu) {
                this.scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
            } else {
                document.documentElement.scrollTop = document.body.scrollTop = this.scrollPos;
            }
        },
        logout() {
            if (this.logoutFunc instanceof Function) {
                this.logoutFunc();
            } else {
                window.location.href = this.logoutUrl || (this._baseUrl + 'logout');
            }
        },
        /** @param {string} elementId */
        focus(elementId) {
            const el = document.getElementById(elementId);
            if (el) {
                el.focus();
            }
        },
        /** @param {boolean} isHidden */
        toggleFocus(isHidden) {
            ['main-content', 'footer-content'].forEach(elementId => {
                const el = document.getElementById(elementId);
                if (el) {
                    if (isHidden) {
                        el.setAttribute('aria-hidden', 'true');
                        el.setAttribute('inert', 'true');
                    } else {
                        el.removeAttribute('aria-hidden');
                        el.removeAttribute('inert');
                    }
                }
            });
        },
    },
};
